<script>

import { createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();

export let item;
export let scale;


function openOnMap(event){    
    dispatch('goto', {
        index: event.target.dataset.listid
    });
    return event.preventDefault();
}
</script>
<style>
a {
    text-decoration: none;
}
article {
    display:grid;    
    grid-template-columns: 28px  1fr 40px;
    margin-bottom: 1em;
    min-height: none;
    background-color:#fff;
    max-width: 660px;
    margin-left:auto;
    margin-right:auto;
}
h1 {
    /* grid-column: 2 / span 2; */
    margin:0;
    order: 1;
    font-size: 1.1em;

}
address {
    /* grid-column: 2 / span 2; */
    order:3;
}

.viewbutton{
    display: inline-block;
    padding: .5em 10px;
    order: 2;
    grid-row-start: span 2;
    font-weight: bold;
    font-family: monospace;
    font-size: 1.5em;
     display:none
}

article:before {
   counter-increment: items; 
   content: counter(items) ". ";
   grid-row-start: span 2;   
   font-weight: bold;
   text-indent: 5px;
   font-size: 13px;   
}

address {
    font-style: normal
}

address span {
    font-weight: bold;
    font-style: italic;
}

span.tmp {
    display:block;
    order:2
}
@media(min-width:760px) {
    .viewbutton {
        display:inline-block;
    }
    span.tmp {
        display:none;
        
    }
}
</style>
<article>
<h1><a href={item.uri} data-category='view_clinic' data-action='internal_link' data-label={item.uri} >{@html item.title}</a></h1>    
    <address>{@html item.address} 

    <span>{#if item[scale] != null}
           - {item[scale]}
        {/if}</span>
    </address>
    <span class='tmp'></span>
    <a href={item.uri}

       data-listid='{item.index}' 
       data-category='show_clinic' 
       data-action='open_infowindow' 
       data-label={item.title}
       class='viewbutton' 
       title={window.mapinfo.translate.more_info} 
       on:click={openOnMap}>&gt;</a>
</article>